import React, { memo } from "react";
import { withNamespaces } from "react-i18next";
import RecentlyActivity from "src/pages/Admin/dashboard/RecentlyActivity";

const RecentActivity = memo(({ t, data = [], isFetching }) => {
    const rows = Array.isArray(data) ? data : [];
    const items = rows.map((item) => {
        const d = item?.updatedAt ? new Date(item.updatedAt) : null;
        const isValidDate = d && !Number.isNaN(d.getTime());
        const dateLabel = isValidDate
            ? d.toLocaleDateString(undefined, { day: "2-digit", month: "short", year: "numeric" })
            : "-";
        const timeLabel = isValidDate
            ? d.toLocaleTimeString(undefined, { hour: "2-digit", minute: "2-digit" })
            : "";

        return {
            dateLabel,
            timeLabel,
            text: item?.aiSystemName
                || (item?.reportCaseId ? `${t("Case ID")}: ${item.reportCaseId}` : t("There is no data")),
            iconClassName: "ri-history-line",
        };
    });

    return (
        <RecentlyActivity
            useCustomData={true}
            items={items}
            isFetching={isFetching}
            title={t("Recent Activity")}
            emptyText={t("No recent activity found.")}
            maxHeight="370px"
            cardClassName="mb-3 flex-grow-1"
            cardStyle={{ height: "460px" }}
        />
    );
});

export default withNamespaces()(RecentActivity);
